import { CardComponent } from '../../../shared/components/card/card.component';
import { Component, inject } from '@angular/core';
import { Button } from '../../../shared/components/button/button.component';
import { Titledescription } from '../../../shared/components/titledescription/titledescription.component';
import { Table } from '../../../shared/components/table/table.component';
import { RouterModule } from '@angular/router';
// Debes crear ESTABLECIMIENTOS_ACTIONS, ESTABLECIMIENTOS_COLUMN_NAMES, ESTABLECIMIENTOS_FIELDS_CONFIG
import { ESTABLECIMIENTOS_ACTIONS, ESTABLECIMIENTOS_COLUMN_NAMES, ESTABLECIMIENTOS_FIELDS_FORM, ESTABLECIMIENTOS_PAGINATE_OPTIONS } from '../../../constants/establecimientos.constants';
import { BaseList } from '../../../shared/baseList.component';
// Debes crear EstablecimientosService
import { EstablecimientosService } from '../../../core/establecimientos.service';
import { EstablecimientoInterface } from '../../../models/establecimiento.model';

@Component({
  selector: 'app-establecimientos',
  imports: [CardComponent , Table, Button, RouterModule, Titledescription],
  templateUrl: './establecimientos-list.html',
  styleUrl: './establecimientos-list.scss'
})
export class Establecimientos extends BaseList<EstablecimientoInterface>{
  entityKey = 'establecimientos';
  apiService = inject(EstablecimientosService);
  columnNames = ESTABLECIMIENTOS_COLUMN_NAMES;
  fields = ESTABLECIMIENTOS_FIELDS_FORM;
  actions = ESTABLECIMIENTOS_ACTIONS;
  paginateOptions = ESTABLECIMIENTOS_PAGINATE_OPTIONS;
}
